import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-16/task-01";

const task: Slide = {
  titleHtml:
    "Consider a 30 cm diameter loudspeaker in a screen radiating in air (acoustic velocity is 340 m/s).<br>Up to which frequency can it be considered as omnidirectional (L<sub>pmin</sub> > L<sub>pmax</sub> - 3dB)?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
